import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  standalone: false,
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: string): SafeHtml {
    const sanitizedHtml = DOMPurify.sanitize(value);
    return this.sanitized.bypassSecurityTrustHtml(sanitizedHtml);
  }
}
